module.exports = __webpack_public_path__ + "img/zhongchuan.da83a160.png";